import RegEx from './FormUtils/RegEx';

export const sumRoundedToTwoDecimals = (
  values: Array<number | string | null | undefined>
): number => {
  const cents = values.reduce((total: number, value) => {
    const numeric = Number(value);

    if (!Number.isFinite(numeric)) {
      return total;
    }

    return total + Math.round((numeric + Number.EPSILON) * 100);
  }, 0);

  return cents / 100;
};

// Display a total with at most 2 decimal places, without trailing zeros.
export const formatRoundedIndian = (value: number | string): string => {
  const numeric = Number(value);

  if (!Number.isFinite(numeric)) {
    return formatIndian(value);
  }

  const fixed = (Math.round((numeric + Number.EPSILON) * 100) / 100).toFixed(
    2
  );
  const [whole, fraction = ''] = fixed.split('.');
  const trimmedFraction = fraction.replace(/0+$/, '');
  const normalized = trimmedFraction ? `${whole}.${trimmedFraction}` : whole;

  return formatIndian(normalized);
};

export const formatIndian = (value: number | string): string => {
  if (value === null) {
    return '-';
  } else if (isNaN(value as number)) {
    if (value === 'N/A') {
      return `${value}`;
    } else {
      return '-';
    }
  } else {
    const string = String(value);
    const stringArray = string.split('.');

    return (
      stringArray[0].replace(RegEx.sumValue, '$1,') +
      (stringArray[1] ? '.' + stringArray[1] : '')
    );
  }
};
